import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { share } from 'rxjs/operators';
import { ApplicationConfig } from '../../config/config';
import {
  AirportListLookupModel,
  CountryListLookupModel,
  DefaultProvincesLookupModel
} from '../../model/airport-lookup.model';

@Injectable({
  providedIn: 'root'
})
export class AirportLookupService {
  private defaultProvincesList: DefaultProvincesLookupModel[] = [];
  private countryList: CountryListLookupModel[] = [];
  private airportList: AirportListLookupModel[] = [];
  private airportListCountryWise: AirportListLookupModel[] = [];
  private airportListProviencesWise: AirportListLookupModel[] = [];
  private airportListAlphabeticallyWise: AirportListLookupModel[] = [];

  constructor(private http: HttpClient, private config: ApplicationConfig) {}

  getDefaultProviences(keyword) {
    if (this.defaultProvincesList.length > 0) {
      return this.defaultProvincesList;
    } else {
      this.defaultProvincesList.length = 0;
      this.getDefaultProviencesFromAPI(keyword).subscribe(
        (data) => {
          if (data) {
            if (this.defaultProvincesList.length > 0) {
              return this.defaultProvincesList;
            } else {
              for (const searchItem of data['listOfProvince']) {
                this.defaultProvincesList.push(
                  new DefaultProvincesLookupModel(
                    searchItem.countryCode,
                    searchItem.stateProvinceCode,
                    searchItem.stateProvinceName
                  )
                );
              }
            }
          }
        },
        (err) => {}
      );
      return this.defaultProvincesList;
    }
  }

  getCountryList() {
    if (this.countryList.length > 0) {
      return this.countryList;
    } else {
      this.getCountryListFromAPI().subscribe(
        (data) => {
          if (data) {
            for (const searchItem of data['listOfCCountries']) {
              this.countryList.push(
                new CountryListLookupModel(
                  searchItem.countryCode,
                  searchItem.countryName
                )
              );
            }
          }
        },
        (err) => {}
      );
      return this.countryList;
    }
  }

  getAirportList(keyword, region, tabValue: string) {
    if (tabValue === 'country') {
      this.airportList = this.airportListCountryWise;
    } else if (tabValue === 'proviences') {
      this.airportList = this.airportListProviencesWise;
    } else if (tabValue === 'alphabetically') {
      this.airportList = this.airportListAlphabeticallyWise;
    }

    let filteredItems: any[] = [];
    if (tabValue === 'alphabetically') {
      filteredItems = this.airportList;
    } else {
      if (this.airportList.length > 0) {
        if (tabValue === 'proviences') {
          filteredItems = this.airportList.filter(function (obj) {
            return (
              obj.region.toLowerCase().indexOf(region.toLowerCase()) !== -1
            );
          });
        } else {
          filteredItems = this.airportList.filter(function (obj) {
            return (
              obj.countryCode.toLowerCase().indexOf(keyword.toLowerCase()) !==
              -1
            );
          });
        }
      }
    }

    if (filteredItems.length > 0) {
      return this.airportList;
    } else {
      this.airportList.length = 0;
      this.getAirportListFromAPI(keyword, region, tabValue).subscribe(
        (data) => {
          if (data) {
            for (const searchItem of data['listOfCities']) {
              this.airportList.push(
                new AirportListLookupModel(
                  searchItem.airportCode,
                  searchItem.airportName,
                  searchItem.awardTktTypCd,
                  searchItem.cityCode,
                  searchItem.cityName,
                  searchItem.cityServe,
                  searchItem.cityType,
                  searchItem.codeShareOnlyInd,
                  searchItem.countryCode,
                  searchItem.eurpnUnionCityInd,
                  searchItem.nonStdFreqOfOperationInd,
                  searchItem.nonStdFreqOfOperationText,
                  searchItem.region,
                  searchItem.timeZone,
                  searchItem.useTimeForAvailability
                )
              );
            }
            if (tabValue === 'country') {
              this.airportListCountryWise = this.airportList;
            } else if (tabValue === 'proviences') {
              this.airportListProviencesWise = this.airportList;
            } else if (tabValue === 'alphabetically') {
              this.airportListAlphabeticallyWise = this.airportList;
            }
          }
        },
        (err) => {}
      );

      return this.airportList;
    }
  }

  getDefaultProviencesFromAPI(keyword: string) {
    return this.http
      .get(
        `${this.config.get('APP_UTIL_LOOKUP_PROVINCES_URL')}?country=${keyword}`
      )
      .pipe(share());
  }

  getCountryListFromAPI() {
    return this.http
      .get(`${this.config.get('APP_UTIL_LOOKUP_COUNTRIES_URL')}`)
      .pipe(share());
  }

  getAirportListFromAPI(keyword: string, region: string, tabValue: string) {
    let apiUrl: string;
    const param = tabValue === 'proviences' ? `?region=${region}` : '';
    const country = keyword;

    // ***************************************************************************************************
    // NOTE: the parameters had to be passed as query strings for 'country' and 'region' (if available)
    // As they are currently in the path url, Express will then rewrite using route params when forwarding
    // ***************************************************************************************************
    apiUrl = `${this.config.get(
      'APP_UTIL_LOOKUP_AIRPORTS_URL'
    )}/${keyword}/asc${param}`;
    return this.http.get(apiUrl).pipe(share());
  }
}
